module.exports = __webpack_public_path__ + "img/sms-tracking_black.78520d7d.svg";